export const STUDENT_ASSESSMENTS_PATH = '/student/assessments';

/** Poll interval for the student live dashboard (AO-1.19). */
export const STUDENT_ASSESSMENT_LIVE_POLL_MS = 10_000;

/** @param {string} id */
export function studentAssessmentPath(id) {
  return `/student/assessments/${id}`;
}

/** @param {string} id */
export function studentAssessmentLivePath(id) {
  return `/student/assessments/${id}/live`;
}

/** @param {string} id */
export function studentAssessmentCompletePath(id) {
  return `/student/assessments/${id}/complete`;
}

/** @param {string} id */
export function studentAssessmentResultsPath(id) {
  return `/student/assessments/${id}/results`;
}

export const STUDENT_ASSESSMENT_SCOPES = Object.freeze([
  { key: 'upcoming', label: 'Upcoming' },
  { key: 'active', label: 'Active' },
  { key: 'past', label: 'Past' },
]);
